export default __webpack_public_path__ + "static/media/ip committee.3ecc5569.png";